import ZoneShow from './ZoneShow'
export {ZoneShow}
export default ZoneShow
